module.exports = __webpack_public_path__ + "static/media/raleway.d276fd0a.fnt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/raleway.fnt
// module id = 372
// module chunks = 0